import { render } from "./flexItem.vue?vue&type=template&id=e552d7be&scoped=true"
import script from "./flexItem.vue?vue&type=script&lang=js"
export * from "./flexItem.vue?vue&type=script&lang=js"

import "./flexItem.vue?vue&type=style&index=0&id=e552d7be&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e552d7be"]])

export default __exports__